// @flow
import React, { useRef } from 'react';
import { useDispatch } from 'react-redux';
import SockJsClient from 'react-stomp';
import { Config } from '../../../latest/src/constants/AppServerConfig';
import { setFlashNotification } from '../../../redux/modules/flashNotification';
import {useLocation } from 'react-router-dom';
import {
    
    setCreateTodo, setRemoveTodo,
} from "../../../redux/actions/todoActions";
import { sanitiseHTML } from '../../../utils/helpers';
import { Logger } from 'src/services';
import { setMeetingInfoZoom } from 'src/redux/actions/questionnaireActions';
type Props = {
    loggedInUser: Object
}

export default function UserServiceSocket({ loggedInUser }: Props): React$Element<any> {
    // const isTherapist = loggedInUser.userRole === userRoles.therapist;

    const headerKeys = { APIKEY: 'test', SECRET: 'test', CLIENTID: loggedInUser.id };
    const subscribeHeaders = { APIKEY: 'test', SECRET: 'test', CLIENTID: loggedInUser.id };

    const socketRef: any = useRef();
    const dispatch = useDispatch();
    // const history = useNavigate();
    const location = useLocation();

  

    const handleReceiveMessage = async (message) => {
        try {
            if (message.message_type === "CREATE_SCHEDULER_TODO") {
              message.type !== 'followUp' && dispatch(setFlashNotification({
                    message: sanitiseHTML( `<p style="color:#374253"> Your client <span style="color:#BD65F0;font-weight:600;">${message.user_full_name} </span> ${message.content.replace('{fullname}', '')}</p>`),
                    duration:10000,
                    isError:true
                }));

                dispatch(setCreateTodo(message));

            }

            if(message.message_type === "CLEAR_SCHEDULER_TODO"){
                dispatch(setRemoveTodo(message));
            }
            
            if(message.message_type === "MEETING_INFORMATION"){
                dispatch(setFlashNotification({ message:"Received Info"}));
                dispatch(setMeetingInfoZoom(message));
            }
        } catch (err) {
            process.env.REACT_APP_ENVIRONMENT === 'dev' || process.env.REACT_APP_ENVIRONMENT === 'qa' ? alert(err) : Logger.log(err);
            dispatch(setFlashNotification({
                message: 'There\'s and error connecting to websocket.',
                isError: true
            }));
        }
    };

  

    const handleConnectionSuccess = async () => {
        try {
            Logger.log('user service websocket: connected successfuly');
            // if (isTherapist && location.pathname.includes('intake')) {
            //     const { waitingRoomMembers } = await getWaitingRoomMembers();

            //     dispatch(setWaitingRoomMembers({ waitingRoomMembers }));
            // }
        } catch (err) {
            process.env.REACT_APP_ENVIRONMENT === 'dev' || process.env.REACT_APP_ENVIRONMENT === 'qa' ? alert(err) : Logger.log(err);

            dispatch(setFlashNotification({
                message: 'There\'s and error connecting to websocket.',
                isError: true,
                duration: 5000
            }));
        }
    };

    const topicSubscriptions = [
        '/topic/scheduler-todo-actions','/user/topic/scheduler-todo-actions'
    ];

    const onConnectFailure = () => {
        if (location.pathname.includes('/therapy/therapist') || location.pathname.includes('/therapy/client')) {
            // setFailure(true);
            // setTimeout(() => {
            //     setFailure(false);
            // }, 1000);
        }
    };

    const onDisconnect = () => {

        if (location.pathname.includes('/therapy/therapist') || location.pathname.includes('/therapy/client') || location.pathname.includes('/scheduler')) {
            Logger.log('websocket: disconnect');
        }
    };

    return   window.location.origin.includes("localhost") ? <></> : <SockJsClient
        ref={socketRef}
        url={`${Config.apiUrl}/${Config.userService}socket`}
        headers={headerKeys}
        subscribeHeaders={subscribeHeaders}
        autoReconnect={true}
        topics={topicSubscriptions}
        onMessage={handleReceiveMessage}
        onConnect={handleConnectionSuccess}
        onConnectFailure={onConnectFailure}
        onDisconnect={onDisconnect}
        heartbeat={10}
        options={{ timeout: 10000 }} 
        />;
}
